import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { CurrencyCell, LinkButton, Table } from 'components/core-v2'

const NameCell = ({ context: { onSelectedRow }, data }: ICellRendererParams<any>) => (
  <LinkButton onClick={() => onSelectedRow(data)}>{data.name}</LinkButton>
)

const ASSET_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 290,
    flex: 0.3,
    cellRenderer: NameCell
  },
  {
    headerName: 'ISIN',
    field: 'code',
    minWidth: 200
  },
  {
    headerName: 'At risk',
    field: 'amountInvestedWithGapRisk',
    minWidth: 200,
    flex: 0.1,
    cellRenderer: CurrencyCell({
      fieldName: 'amountInvestedWithGapRisk',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  },
  {
    headerName: 'Delta One',
    field: 'amountInvestedWithoutGapRisk',
    minWidth: 220,
    flex: 0.1,
    cellRenderer: CurrencyCell({
      fieldName: 'amountInvestedWithoutGapRisk',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  },
  {
    headerName: 'Holdings',
    field: 'holdings',
    minWidth: 220,
    flex: 0.1,
    cellRenderer: CurrencyCell({
      fieldName: 'holdings',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  }
]

const ASSET_INNER_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 200,
    flex: 0.3
  },
  {
    headerName: 'ISIN',
    field: 'code',
    minWidth: 150,
    flex: 0.1
  },
  {
    headerName: 'At risk',
    field: 'amountInvestedWithGapRisk',
    minWidth: 100,
    flex: 0.2,
    cellRenderer: CurrencyCell({
      fieldName: 'amountInvestedWithGapRisk',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  },
  {
    headerName: 'Delta 1',
    field: 'amountInvestedWithoutGapRisk',
    minWidth: 100,
    flex: 0.2,
    cellRenderer: CurrencyCell({
      fieldName: 'amountInvestedWithoutGapRisk',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  },
  {
    headerName: 'Holdings',
    field: 'holdings',
    minWidth: 100,
    flex: 0.2,
    cellRenderer: CurrencyCell({
      fieldName: 'holdings',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  }
]

const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}

export interface ConstituentAsset {
  amountInvestedWithGapRisk?: number | null
  amountInvestedWithoutGapRisk?: number | null
  aum?: number | null
  code: string | null
  currency?: string | null
  name: string | null
  originalCurrency: string
  region: string
}

export interface AssetLookthroughTableProps {
  data: ConstituentAsset[]
  // eslint-disable-next-line react/no-unused-prop-types
  onSelectedRow?: (selectedRow: ConstituentAsset) => void
}

export const AssetLookthroughTable = ({ data, onSelectedRow }: AssetLookthroughTableProps) => {
  const rowData = data.map(row => ({
    ...row,
    holdings: row.amountInvestedWithGapRisk + row.amountInvestedWithoutGapRisk
  }))

  return (
    <Table
      agGridProps={{
        columnDefs: ASSET_COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44,
        pagination: true,
        context: {
          onSelectedRow
        }
      }}
      height="600px"
    />
  )
}
export const AssetInnerTable = ({ data }: AssetLookthroughTableProps) => {
  const rowData = data.map(row => ({
    ...row,
    holdings: row.amountInvestedWithGapRisk + row.amountInvestedWithoutGapRisk
  }))

  return (
    <Table
      agGridProps={{
        columnDefs: ASSET_INNER_COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44
      }}
      height="500px"
    />
  )
}
export default AssetLookthroughTable
